import Icon from '../components/Icon';
// src/pages/AccessDenied.js
import React from 'react';

export default function AccessDenied({ user, onLogout }) {
  return (
    <div className="access-denied-page">
      <div className="access-denied-card">
        <div className="access-denied-header" style={{ background: 'var(--red)' }}>
          <Icon size={36} />
          <div>
            <div className="access-denied-brand-name">SUFC Secure Transfer System</div>
          </div>
        </div>
        <div className="access-denied-body">
          <div className="access-denied-icon">🔒</div>
          <div className="access-denied-title">Access denied</div>
          <div className="access-denied-msg">
            Your account is not authorised to access this system.
            If you believe this is a mistake, please contact the IT Department.
          </div>
          {user?.email && (
            <div className="access-denied-account">Signed in as: {user.email}</div>
          )}
          <div className="access-denied-actions">
            <button className="btn btn-primary" style={{ justifyContent: 'center' }} onClick={onLogout}>
              Sign out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
